export class LargeApplicationNotificationMessages {
    public static ModalTitle = 'Large Application Notification';
    public static ModalButtonTitle = 'Return to Dashboard';
    public static ModalContent =
        'This application has many sites and/or frequencies. It may take longer to build than normal. Please check your Cevo Dashboard in a few minutes. The application will appear when it is ready for you to proceed.';
    public static ApplicationAvailableMessage =
        'Your application is now available on the dashboard.';
}
